module.exports = __webpack_public_path__ + "media/icons/upload-61d3fbb9.svg";